import { NUMBER_OF_PROPERTIES_PER_PAGE } from "../constants";
export var getFirstPropertyIndexOfActivePage = function getFirstPropertyIndexOfActivePage(activePage) {
  return NUMBER_OF_PROPERTIES_PER_PAGE * activePage - NUMBER_OF_PROPERTIES_PER_PAGE;
};